// @flow

import * as React from 'react';

import styles from './SlushBanner.scss';

import icon from 'images/partners/slush/logo-small-black.png';

export default function SlushBanner() {
  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <img className={styles.logo} src={icon} width="120" height="40" />
        <p>
          Organizing a Slush side event? Our venue experts will help you find
          the best venue and any services you might need – for free!
        </p>
        <a
          href="https://l.venuu.fi/slush-side-events"
          target="_blank"
          className={styles.cta}
        >
          Contact
        </a>
      </div>
    </div>
  );
}
